<section class="tw-bg-white">
    <div
        class="tw-max-w-[1380px] tw-mx-auto tw-py-[50px] tw-px-[30px] tw-flex tw-gap-4 tw-flex-col sm:tw-flex-row"
    >
        <div class="tw-flex-1 tw-flex tw-items-center">
            <div class="tw-max-w-[495px] tw-mx-auto">
                <h2
                    class="!tw-font-bold !tw-text-[24px] lg:!tw-text-[30px] !tw-text-[#0F3172] tw-mb-4 !tw-leading-[1.5] lg:!tw-leading-[50px]"
                >
                    {{ "PARTNERS.PARTNERSHIP_PROGRAMME_TITLE" | translate }}
                </h2>
                <p
                    class="!tw-text-[14px] sm:!tw-text-[16px] md:!tw-text-[18px]"
                >
                    {{ "PARTNERS.PARTNERSHIP_PROGRAMME_DESC" | translate }}
                </p>
            </div>
        </div>
        <div class="tw-flex-1">
            <div
                class="tw-relative tw-w-[315px] lg:tw-w-[712px] tw-h-[371px] tw-m-auto lg:tw-h-[467px] tw-max-w-[712px] tw-flex tw-items-end tw-rounded-[16px] tw-overflow-hidden tw-cursor-pointer"
                (click)="emitPartnershipDialog(partnershipData[0]?.id)"
            >
                <img
                    [attr.ga-event-id]="
                    partnershipData[0]?.partnershipDetails?.partnershipName +
                    '_partnership_card_click'
                    "
                    ga-event-category="Partnership Button"
                    [attr.ga-event-label]="
                    partnershipData[0]?.partnershipDetails?.partnershipName +
                    ' Partnership Button Click'
                    "
                    ga-track="track"
                    src="/assets/images/partnership/borong.png"
                    alt="Partnership"
                    class="tw-absolute tw-hidden sm:tw-block tw-left-0 tw-h-full tw-w-full tw-top-0"
                />
                <img
                    [attr.ga-event-id]="
                    partnershipData[0]?.partnershipDetails?.partnershipName +
                    '_partnership_card_click'
                    "
                    ga-event-category="Partnership Button"
                    [attr.ga-event-label]="
                    partnershipData[0]?.partnershipDetails?.partnershipName +
                    ' Partnership Button Click'
                    "
                    ga-track="track"
                    src="/assets/images/partnership/borong-mb.png"
                    alt="Partnership"
                    class="tw-absolute tw-block sm:tw-hidden tw-left-0 tw-h-full tw-w-full tw-top-0"
                />
                <div
                    class="tw-relative tw-w-full tw-bg-[linear-gradient(179.68deg,_rgba(198,198,198,0)_-2.4%,_#E5E5E5_61.04%)] tw-p-4"
                >
                    <h4
                        class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold"
                    >
                        {{
                            partnershipData[0]?.partnershipDetails
                                ?.partnershipName
                        }}
                    </h4>
                    <span
                        class="tw-text-[14px] tw-text-[#2A2A2A]"
                        [innerHTML]="
                            removeHtmlTags(
                                partnershipData[0]?.partnershipDetails
                                    ?.shortDesc
                            )
                        "
                    >
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
